import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, state } = useLocation();
  const prevPathnameRef = useRef();

  useEffect(() => {
    // Always scroll to top when landing on the home page — this covers:
    //   - Logout navigation (navigate('/') from any page, even if already on '/')
    //   - Pre-login landing (user arrives at '/' before authenticating)
    //   - Normal forward navigation to '/'
    const navigatingToHome = pathname === '/';

    // For all other routes, only scroll to top when the path actually changes
    // and the navigation state doesn't indicate we should preserve scroll.
    const shouldScrollToTop = navigatingToHome ||
      (!state?.preserveScroll && prevPathnameRef.current !== pathname);

    if (shouldScrollToTop) {
      // The app uses overflow scroll on .main-content, not window
      const mainContent = document.querySelector('.main-content');
      if (mainContent) {
        mainContent.scrollTop = 0;
      } else {
        window.scrollTo(0, 0);
      }
    }

    prevPathnameRef.current = pathname;
  }, [pathname, state]);

  return null;
};

export default ScrollToTop;
